function initStars() {
    // ── Canvas setup ────────────────────────────────────────
    const canvas = document.createElement('canvas');
    canvas.id = 'stars-canvas';
    Object.assign(canvas.style, {
        position: 'fixed',
        inset: '0',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: '1',
        opacity: '0',
        transition: 'opacity 1s ease'
    });
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    const GOLD = [
        201,
        169,
        110
    ]; // --gold
    const DARK_BG = [
        44,
        36,
        25
    ]; // --charcoal
    function resize() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);
    // ── Estrella ─────────────────────────────────────────────
    function rand(a, b) {
        return a + Math.random() * (b - a);
    }
    function makeStar() {
        const angle = rand(-0.35, -0.15); // dirección diagonal suave
        const speed = rand(0.5, 1.8); // muy lenta
        return {
            x: rand(-canvas.width * 0.1, canvas.width * 1.1),
            y: rand(-30, canvas.height * 0.5),
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed + 0.4,
            len: rand(50, 100),
            alpha: rand(0.12, 0.28),
            width: rand(0.6, 1.7),
            life: 0,
            maxLife: rand(150, 280),
            delay: rand(0, 300)
        };
    }
    const STAR_COUNT = 5;
    const stars = Array.from({
        length: STAR_COUNT
    }, makeStar);
    let tick = 0;
    // ── Visibilidad sincronizada con el fondo ────────────────
    // Comprobamos el backgroundColor del body para saber si estamos
    // en una sección oscura y ajustamos la opacidad del canvas.
    let lastIsDark = false;
    function syncVisibility() {
        // getComputedStyle es más fiable que .style.backgroundColor para valores animados/transicionados
        const bg = window.getComputedStyle(document.body).backgroundColor;
        const match = bg.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
        if (!match) return;
        const r = Number(match[1]);
        const g = Number(match[2]);
        const b = Number(match[3]);
        // Luminosidad percibida (0-255): < 80 = oscuro
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        const isDark = luminance < 80;
        if (isDark !== lastIsDark) {
            canvas.style.opacity = isDark ? '1' : '0';
            lastIsDark = isDark;
        }
    }
    // Observar cambios en el backgroundColor del body con MutationObserver
    const mo = new MutationObserver(syncVisibility);
    mo.observe(document.body, {
        attributes: true,
        attributeFilter: [
            'style'
        ]
    });
    // Polling de respaldo cada 200ms para capturar transiciones CSS intermedias
    setInterval(syncVisibility, 200);
    syncVisibility(); // estado inicial
    // ── Loop de dibujo ───────────────────────────────────────
    function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        stars.forEach((s)=>{
            if (tick < s.delay) return;
            s.life++;
            if (s.life > s.maxLife) {
                Object.assign(s, makeStar());
                s.life = 0;
                s.delay = 0;
                return;
            }
            // Fade in/out
            const fadeIn = Math.min(1, s.life / 30);
            const fadeOut = Math.max(0, 1 - (s.life - s.maxLife * 0.65) / (s.maxLife * 0.35));
            const alpha = s.alpha * fadeIn * fadeOut;
            if (alpha <= 0) {
                s.x += s.vx;
                s.y += s.vy;
                return;
            }
            // Cola: desde la punta hacia atrás
            const spd = Math.sqrt(s.vx * s.vx + s.vy * s.vy);
            const tx = s.x - s.vx / spd * s.len;
            const ty = s.y - s.vy / spd * s.len;
            const grd = ctx.createLinearGradient(s.x, s.y, tx, ty);
            grd.addColorStop(0, `rgba(${GOLD},${alpha})`);
            grd.addColorStop(0.4, `rgba(${GOLD},${alpha * 0.4})`);
            grd.addColorStop(1, `rgba(${GOLD},0)`);
            ctx.beginPath();
            ctx.strokeStyle = grd;
            ctx.lineWidth = s.width;
            ctx.moveTo(s.x, s.y);
            ctx.lineTo(tx, ty);
            ctx.stroke();
            s.x += s.vx;
            s.y += s.vy;
        });
        tick++;
        requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
}

//# sourceMappingURL=public.fb7ee50d.js.map
